import { render, staticRenderFns } from "./DeletedCustomers.vue?vue&type=template&id=6d699abc&"
import script from "./DeletedCustomers.vue?vue&type=script&lang=js&"
export * from "./DeletedCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports